import { DragIcon } from "components/atoms/Icon";

function DragHandle() {
    return (
        <div style={{ cursor: "grab" }}>
            <DragIcon />
        </div>
    );
}

export default DragHandle;
